import { render, staticRenderFns } from "./branded-fare-card.vue?vue&type=template&id=2fc83322&scoped=true"
import script from "./branded-fare-card.vue?vue&type=script&lang=js"
export * from "./branded-fare-card.vue?vue&type=script&lang=js"
import style0 from "./branded-fare-card.vue?vue&type=style&index=0&id=2fc83322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc83322",
  null
  
)

export default component.exports